import React, {Component} from 'react';
import {withStyles} from '@material-ui/core';
import {Helmet} from "react-helmet";
import {metaDescriptions, metaImages, metaTitles} from "../../website-utils/meta";
import ScrollToTopOnMount from "../../website-utils/ScrollToTopOnMount";
import logoBlack from '../../assets/images/logo-black.png';
import shiftPageHero from '../../assets/images/blackfairy.jpg';
import {Link} from "react-router-dom";
import config, {AIRTABLE_HOOKS_ROOT, API_ROOT} from "../../config";


class ShiftPageBurp extends Component {
  constructor(props) {
    super(props);
    this.data = {
      job_type: 'Part Timer',
      business_name: 'BlackFairy Coffee',
      date: 'Thursday 6 Sep to Saturday 8 Sep',
      start_time: '11:00AM',
      end_time: '5:00PM',
      wage: 7,
      neighborhood: 'Near City Square Mall',
      address: '131 Tyrwhitt Rd, 207553',
      maps: 'https://goo.gl/maps/4pout1BhTqT2',
      attire: 'Jeans. A Blackfairy Coffee polo tee will be provided.',
      duties: 'Wash cutlery using the dishwasher.',
    }
  }

  componentDidMount() {
    window.analytics.page("Shift");
  }

  render() {
    window.prerenderReady = true;

    const {classes} = this.props;

    return (
      <div className={classes.shiftPage}>
        <ScrollToTopOnMount/>
        <Helmet>
          {metaTitles(`${this.data.job_type.toString()} for ${this.data.business_name.toString()}`)}
          {metaDescriptions(`${this.data.job_type.toString()} for ${this.data.business_name.toString()} on ${this.data.date.toString()} from ${this.data.start_time.toString()} to ${this.data.end_time.toString()} in ${this.data.neighborhood.toString()}. SGD ${this.data.wage.toString()} per hour.`)}
          {metaImages(`${window.location.origin}${shiftPageHero}`)}
        </Helmet>
        <div className={classes.header}>
          <div className='container'>
            <div className="row justify-content-md-center">
              <div className="col-md-8 col-sm-12">
                <a href={'https://www.singleshift.sg/pros'}>
                  <img className="logo" src={logoBlack}/>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Shift Image */}
        <div id='hero'>
          <div className='container'>
            <div className='row justify-content-md-center'>
              <div className='col-md-8 col-sm-12'>
                <img src={shiftPageHero} className='img-fluid' width='940'/>
              </div>
            </div>
          </div>
        </div>

        {/* Shift Information */}
        <div className='container'>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h1 className={classes.shiftName}>{`${this.data.job_type.toString()} for ${this.data.business_name.toString()}`}</h1>
              <p className={classes.shiftDate}>{`${this.data.date.toString()} from ${this.data.start_time.toString()} to ${this.data.end_time.toString()}`}</p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-4 col-sm-6'>
              <h3 className={classes.shiftLabel}>Wage</h3>
              <p className={classes.shiftWage}>SGD {`${this.data.wage.toString()}`} per hour</p>
            </div>
            <div className='col-md-4 col-sm-6'>
              <h3 className={classes.shiftLabel}>Job Type</h3>
              <p className={classes.shiftJob}>{`${this.data.job_type.toString()}`}</p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>Address</h3>
              <p className={classes.shiftAddress}>{`${this.data.neighborhood.toString()}`} (<a href={`${this.data.maps.toString()}`} target="_blank">{`${this.data.address.toString()}`}</a>)</p>
            </div>
          </div>
          { this.data.attire &&
            <div className='row justify-content-md-center'>
              <div className='col-md-8 col-sm-12'>
                <h3 className={classes.shiftLabel}>Attire</h3>
                <p>{`${this.data.attire}`}</p>
              </div>
            </div>
          } { this.data.duties &&
            <div className='row justify-content-md-center'>
              <div className='col-md-8 col-sm-12'>
                <h3 className={classes.shiftLabel}>Duties</h3>
                <p>{`${this.data.duties}`}</p>
              </div>
            </div>
          }
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>About BlackFairy Coffee</h3>
              <p>Something mystical is brewing at a neighbourhood near you. We’ve taken top-grade coffee beans, the freshest Poké bowls, your favourite savoury mains and – poof – created a space where you can come and enjoy all the magic.</p>
              <p><a href="https://www.facebook.com/blackfairycoffeesg/">https://www.facebook.com/blackfairycoffeesg/</a></p>
            </div>
          </div>
        </div>

        {/* Shift Actions*/}
        <div className={`container ${classes.shiftActions}`}>
          <div className='row justify-content-md-center'>
            <div className='col-md-4 col-sm-6'>
              <div className={classes.shiftBox}>
                <h3 className={classes.shiftLabel}>Have an account?</h3>
                <p>Reply YES via SMS</p>
              </div>
            </div>
            <div className='col-md-4 col-sm-6'>
              <div className={classes.shiftBox}>
                <h3 className={classes.shiftLabel}>Don't have an account?</h3>
                <a href={'https://www.singleshift.sg/pros'}>Sign up</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default withStyles((theme) => ({
  header: {
    padding: '20px 0',
  },
  shiftPage: {
    marginBottom: '50px',
    '& p': {
      fontSize: '16px',
      lineHeight: '25px',
      marginBottom: '20px'
    },
  },
  shiftSection: {
    borderBottom: '1px solid #ccc',
    marginBottom: '30px',
    paddingBottom: '10px',
  },
  shiftName: {
    fontSize: '20px',
    fontWeight: 'bold',
    lineHeight: '35px',
    marginTop: '15px',
    marginBottom: 0,
    [theme.breakpoints.up('md')]: {
      fontSize: '30px',
      lineHeight: '45px',
    },
  },
  shiftActions: {
    marginTop: '20px',
  },
  shiftLabel: {
    fontSize: '16px',
    lineHeight: '25px',
    fontWeight: 'bold',
    marginBottom: 0,
  },
  shiftBox: {
    border: '1px solid #ccc',
    padding: '15px 10px',
    marginBottom: '20px',
    '& p': {
      marginBottom: '0'
    },
  },
}))(ShiftPageBurp);



// WEBPACK FOOTER //
// ./src/pages/shift-pages/ShiftPageBlackFairy97.js